<template>
  <div
    class="class-display-item"
    :class="{
      'is-selected': isSelected,
    }"
  >
    <div class="class-name">{{ formatClass(classData) }}</div>
  </div>
</template>

<script>
export default {
  name: "ClassDisplayItem",

  props: {
    classData: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatClass(classData) {
      if (!classData || !classData.schoolName) {
        return "Unknown Class";
      }
      return `${classData.schoolName}${
        classData.groupName ? ` | ${classData.groupName}` : ""
      }`;
    },
  },
};
</script>

<style scoped>
.class-display-item {
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.class-display-item:hover {
  background-color: #f8f9fa;
}

.is-selected {
  background-color: #ecf4fe;
  border-left: 4px solid #3273dc;
}

.class-name {
  font-weight: 500;
  color: #363636;
}
</style>
